export default {
  login: {
    title: 'Anmeldung',
    subtitle: 'Willkommen im Tool OÖML Acitivites',
    email: 'E-Mail',
    email_placeholder: 'E-Mail-Adresse eingeben',
    email_restore_placeholder: 'Bitte E-Mail-Adresse eingeben',
    password: 'Passwort',
    password_placeholder: 'Passwort eingeben',
    confirm_password: 'Bitte bestätigen Sie ihr Passwort',
    confirm_placeholder: 'Bitte Passwort bestätigen',
    forgot_password: 'Passwort vergessen?',
    forgot_subtitle: 'Kein Problem! Sie erhalten neue Zugangsdaten.',
    submit: 'Einloggen',
    reset: 'Passwort zurücksetzen',
    back_to_login: 'Zurück zum Login',
    check_email: 'Bitte prüfen Sie ihren Maileingang!',
    check_email_text:
      'Wir haben Ihnen eine Mail zum Zurücksetzen Ihres Passworts übermittelt',
    receive_email: 'Sie haben noch keine Mail erhalten?',
    click_resend: 'Klicken Sie hier!',
    password_reset: 'Passwort zurücksetzen',
    current_password: 'Aktuelles Passwort',
    new_password_change: 'Neues Passwort',
    current_password_placeholder: 'Aktuelles passwort eingeben',
    new_password_change_placeholder: 'Neues passwort eingeben',
    password_success:
      'Ihr Passwort wurde erfolgreich zurückgesetzt! Klicken Sie auf weiter, um sich einzuloggen.',
    continue: 'Weiter',
    new_password: 'Passwort bestätigen',
    new_password_subtitle:
      'Ihr neues Passwort darf nicht dem alten Passwort entsprechen',
    logout_text: 'Sicher, dass Sie sich ausloggen wollen?',
    invite: 'Erfolgreich',
    invite_success:
      'Sie haben sich erfolgreich registriert. Klicken Sie auf weiter, um sich einzuloggen.',
    change_password: 'Passwort ändern',
    deactivated:
      'Ihr Nutzerkonto ist aktuell deaktiviert. Bitte melden Sie sich bei Ihren Vorgesetzten um Ihr Nutzerkonto wieder freizuschalten.',
  },
  symbol: {
    character: 'Zumindest 6 Zeichen lang',
    uppercase: 'Groß- und Kleinbuchstaben',
    number: 'Buchstaben und Zahlen',
    special_character: 'Zumindest ein Sonderzeichen z.B.',
    password_requires:
      'Das Passwort muss Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen beinhalten',
  },
}
